import EnrolledGroupsBanner from './EnrolledGroupsBanner';

export default EnrolledGroupsBanner;
